// export * from "./fleetManager/preventiveMaintenance";

import { useEffect } from "react";
import { FullPageLoading } from "../utils/loading";
import { useIntl } from "react-intl";
import { fetchUserRole } from "../api/fetchUser";
import { UserRoleEnum } from "../enums/role";

export const Main = () => {
    const intl = useIntl();
    useEffect(() => {
        const fetchData = async () => {
            const role = await fetchUserRole();
            if(role === UserRoleEnum.CONSULTANT || role === UserRoleEnum.GROUP_CONSULTANT) {
                window.location.href = "/dealership";
                return;
            }

            if(role === UserRoleEnum.MANAGER) {
                window.location.href = "/fleet-manager";
                return;
            }

            if(role === UserRoleEnum.TOWER) {
                window.location.href = "/control-tower";
                return;
            }

            if(role === UserRoleEnum.PARTNERSHIP) {
                window.location.href = "/partnership";
                return;
            }
        }

        fetchData();
    }, []);

    return <FullPageLoading label={intl.formatMessage({ id: "intl-msg:common.pages.loading" })} />
}
